import * as jsxRuntime from "/Users/ray/Develop/workspace/web/sunrise-official-web/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment